<button
  type="button"
  class="relative bg-none border-2 border-transparent cursor-pointer p-2 rounded-sm transition-all duration-200 hover:bg-gray-4"
  data-testid="notifications-button"
  [attr.aria-label]="TRANSLATION_KEYS.header.NOTIFICATIONS | translate"
  [attr.aria-describedby]="shouldShowBadge ? 'notification-count' : null"
  (click)="onNotificationClick()"
  (keydown.enter)="onNotificationClick()"
  (keydown.space)="onNotificationClick()"
>
  <p-overlayBadge
    *ngIf="shouldShowBadge"
    [value]="badgeValue"
    severity="danger"
    badgeSize="small"
    [attr.id]="'notification-count'"
  >
    <svg-icon
      src="assets/icons/bell.svg"
      class="w-6 h-6 text-black"
      [svgAriaLabel]="''"
    />
  </p-overlayBadge>

  <svg-icon
    *ngIf="!shouldShowBadge"
    src="assets/icons/bell.svg"
    class="w-6 h-6 text-black"
    [svgAriaLabel]="''"
  />
</button>